import firebase from "firebase";

export default {
  methods: {
    uploadToolImage(imgDataUrl) {
      return new Promise((res, rej) => {
        let result = "";
        var characters =
          "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        var charactersLength = characters.length;
        for (var i = 0; i < 15; i++) {
          result += characters.charAt(
            Math.floor(Math.random() * charactersLength)
          );
        }
        var storageRef = firebase.storage().ref(`tool_img/${result}`);

        var metadata = {
          contentType: "image/jpeg"
        };
        var uploadTask = storageRef.putString(imgDataUrl, "data_url");

        uploadTask.on(
          "state_changed",
          snapshot => {
            var progress =
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            console.log("Upload is " + progress + "% done");
            switch (snapshot.state) {
              case firebase.storage.TaskState.PAUSED: // or 'paused'
                console.log("Upload is paused");
                break;
              case firebase.storage.TaskState.RUNNING: // or 'running'
                console.log("Upload is running");
                break;
            }
          },
          error => {
            rej(error);
            console.log("Error uploading image: ", error);
          },
          () => {
            uploadTask.snapshot.ref
              .getDownloadURL()
              .then(downloadURL => {
                res(downloadURL);
              })
              .catch(error => {
                rej(error);
                console.log("Error uploading image: ", error);
              });
          }
        );
      });
    },
    uploadJATImage(imgDataUrl) {
      return new Promise((res, rej) => {
        let result = "";
        var characters =
          "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        var charactersLength = characters.length;
        for (var i = 0; i < 15; i++) {
          result += characters.charAt(
            Math.floor(Math.random() * charactersLength)
          );
        }
        var storageRef = firebase.storage().ref(`jat_img/${result}`);

        var metadata = {
          contentType: "image/jpeg"
        };
        var uploadTask = storageRef.putString(imgDataUrl, "data_url");

        uploadTask.on(
          "state_changed",
          snapshot => {
            var progress =
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            console.log("Upload is " + progress + "% done");
            switch (snapshot.state) {
              case firebase.storage.TaskState.PAUSED: // or 'paused'
                console.log("Upload is paused");
                break;
              case firebase.storage.TaskState.RUNNING: // or 'running'
                console.log("Upload is running");
                break;
            }
          },
          error => {
            rej(error);
            console.log("Error uploading image: ", error);
          },
          () => {
            uploadTask.snapshot.ref
              .getDownloadURL()
              .then(downloadURL => {
                res(downloadURL);
              })
              .catch(error => {
                rej(error);
                console.log("Error uploading image: ", error);
              });
          }
        );
      });
    },
    uploadPublishingCover(imgDataUrl) {
      return new Promise((res, rej) => {
        let result = "";
        var characters =
          "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        var charactersLength = characters.length;
        for (var i = 0; i < 15; i++) {
          result += characters.charAt(
            Math.floor(Math.random() * charactersLength)
          );
        }
        var storageRef = firebase
          .storage()
          .ref(`publishing_cover_img/${result}`);

        var metadata = {
          contentType: "image/jpeg"
        };
        var uploadTask = storageRef.putString(imgDataUrl, "data_url");

        uploadTask.on(
          "state_changed",
          snapshot => {
            var progress =
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            console.log("Upload is " + progress + "% done");
            switch (snapshot.state) {
              case firebase.storage.TaskState.PAUSED: // or 'paused'
                console.log("Upload is paused");
                break;
              case firebase.storage.TaskState.RUNNING: // or 'running'
                console.log("Upload is running");
                break;
            }
          },
          error => {
            rej(error);
            console.log("Error uploading image: ", error);
          },
          () => {
            uploadTask.snapshot.ref
              .getDownloadURL()
              .then(downloadURL => {
                res(downloadURL);
              })
              .catch(error => {
                rej(error);
                console.log("Error uploading image: ", error);
              });
          }
        );
      });
    }
  }
};
